import Avatar from "../Framework/Components/Avatars/Avatar";
import React from "react";
import {avatarSize, ToggleType} from "../Framework/Data/Enums/Generic";
import {useClientAccountOverview} from "../Api/ClientEndpoints";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import DropdownMenu from "../Framework/Components/DropdownMenus/DropdownMenu";
import ItemMenuEntry from "../Framework/Components/Navigation/ItemMenuEntry";
import {
    faCloudMoon,
    faCompress,
    faCreditCard,
    faEllipsisVertical,
    faMoneyBill,
    faPersonToDoor,
    faReceipt,
} from "@fortawesome/pro-solid-svg-icons";
import {useLayout} from "../Framework/Providers/LayoutProvider";
import ToggleSwitch from "../Framework/Components/Forms/Toggle/ToggleSwitch";
import {FormatCurrency} from "../Framework/Constants/Helpers";
import {useUKPBAuth} from "../Providers/AuthProvider";

const UserMenu = () => {
    const userInfo = useClientAccountOverview();
    const { theme, toggleTheme, compacter, toggleCompacter, sidebarOpen, isUltraWide } = useLayout();

    const {
        LogOut,
    } = useUKPBAuth();

    return (
        <div className={'navigation-group hide-sm mt-a'}>
            <div className={'side-navigation-divider'}></div>
            <div className={'user-options-menu side-navigation-entry side-navigation-user-entry collapsable'} tabIndex={0}>
                <Avatar size={avatarSize.Small} />
                {(sidebarOpen || isUltraWide) &&  (
                    <>
                        <div className={'navigation-label mr-a'}>
                            {userInfo.data?.name}
                            <span className={'navigation-sub-label'}>{FormatCurrency(userInfo.data?.balance)}</span>
                        </div>
                        <FontAwesomeIcon icon={faEllipsisVertical} fixedWidth={true} />
                    </>
                )}
            </div>
            <DropdownMenu target={['user-options-menu']}>
                <ItemMenuEntry title={'Top-up'} url={'/payment/top-up'} icon={<FontAwesomeIcon icon={faCreditCard} fixedWidth={true} />} addonContent={<small className={'fade'}>{FormatCurrency(userInfo.data?.balance)}</small>} />
                <ItemMenuEntry title={'Transactions'} url={'/user/transactions'} icon={<FontAwesomeIcon icon={faMoneyBill} fixedWidth={true} />} />
                <ItemMenuEntry title={'Statements'} url={'/user/statements'} icon={<FontAwesomeIcon icon={faReceipt} fixedWidth={true} />} />

                <ItemMenuEntry title={'Divider'} sectionDivider={true} />

                <ItemMenuEntry
                    title={'Dark Mode'}
                    callback={() => toggleTheme()}
                    icon={<FontAwesomeIcon icon={faCloudMoon} fixedWidth={true} />}
                    addonContent={<ToggleSwitch type={ToggleType.Switch} label={'Dark Mode'} name={'darkMode'} checked={theme === 'dark'} />}
                />

                <ItemMenuEntry
                    title={'Compact Mode'}
                    callback={() => toggleCompacter()}
                    icon={<FontAwesomeIcon icon={faCompress} fixedWidth={true} />}
                    addonContent={<ToggleSwitch type={ToggleType.Switch} label={'Compact Mode'} name={'compactMode'} checked={compacter} />}
                />

                <ItemMenuEntry title={'Divider'} sectionDivider={true} />

{/*                <ItemMenuEntry title={'Download App'} url={'/get-app'} icon={<FontAwesomeIcon icon={faMobileAlt} fixedWidth={true} />} />*/}
                <ItemMenuEntry title={'Log Out'} callback={() => LogOut()} icon={<FontAwesomeIcon icon={faPersonToDoor} fixedWidth={true} />} />
            </DropdownMenu>
        </div>
    )
}

export default UserMenu